module.exports = __webpack_public_path__ + "static/img/industrial-storage-container_64.2523eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industrial-storage-container_64.png
// module id = Z7li
// module chunks = 0